export const ADD_DATA = "ADD_DATA"
export const REMOVE_DATA = "REMOVE_DATA"
